// extracted by mini-css-extract-plugin
module.exports = {"container":"_3p8ij","desc":"_21zQn","title":"_2Abel","bgImg":"_3_W8x","buttonStar":"_3UvIX","button":"_2MaD4","buttonArrow":"_2jZuO","bannerLink":"_2DrBb"};